"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LitigationApplication = void 0;
const vue_1 = require("vue");
const complex_plugin_1 = require("complex-plugin");
const complex_data_1 = require("complex-data");
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const dict_1 = require("@/pages/index/select/dict");
const dictionary_1 = require("@/config/dictionary");
const config_1 = require("@/config/dictionary/config");
const select_1 = require("@/pages/index/select");
const ContractArea_vue_1 = __importDefault(require("./list/components/ContractArea.vue"));
const litigationApplicationFlowConfig_1 = require("./litigationApplicationFlowConfig");
class LitigationApplication extends complex_data_1.ComplexList {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            litigation_1.default.litigationApplicationBuild.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('发起诉讼审批成功！', 'success');
                this.$triggerLife('buildItem', this);
                this.$reloadData(true).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            litigation_1.default.litigationApplicationChange.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('诉讼申请审批成功！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    rejectItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            litigation_1.default.litigationApplicationReject.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('诉讼申请驳回完成！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    refuseItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            litigation_1.default.litigationApplicationRefuse.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('诉讼申请拒绝完成！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.LitigationApplication = LitigationApplication;
const litigationApplication = new LitigationApplication({
    name: '诉讼申请',
    prop: 'litigationApplication',
    module: {
        pagination: true,
        dictionary: {
            layout: {
                default: {
                    grid: 24,
                    label: 3,
                    content: 21
                },
                log_info: {
                    grid: 6,
                    label: 8,
                    content: 16
                },
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'id',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'code',
                    name: '申请编号',
                    originProp: 'code',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.contractNumber,
                            local: {
                                fixed: 'left'
                            },
                            render(payload) {
                                return (0, vue_1.h)('span', {
                                    class: 'local-main-link',
                                    onClick() {
                                        (0, litigationApplicationFlowConfig_1.toLitigationApplication)(payload.record.id, 'id', 'end');
                                    }
                                }, payload.text);
                            }
                        },
                        edit: {
                            type: 'input',
                            disabled: true,
                            required: true
                        },
                        ufo_cs_ss_10: {
                            $target: 'edit'
                        },
                        log_info: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'applyUserId',
                    name: 'applyUserId',
                    originProp: 'applyUserId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'applyStatusTime',
                    name: '审核状态更新时间',
                    originProp: 'applyStatusTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'procInsId',
                    name: 'procInsId',
                    originProp: 'procInsId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'deploymentId',
                    name: 'deploymentId',
                    originProp: 'deploymentId',
                    originFrom: 'list',
                    mod: {}
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.LITIGATION_TYPE, {
                    prop: 'litigationType',
                    name: '诉讼类型',
                    originProp: 'litigationType',
                    mod: {
                        list: {},
                        edit: {
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        },
                        ufo_cs_ss_10: {
                            $target: 'edit'
                        },
                        log_info: {
                            $target: 'edit'
                        }
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.LITIGATION_REQUEST_TYPE, {
                    prop: 'litigationRequestType',
                    name: '诉讼请求',
                    originProp: 'litigationRequestType',
                    mod: {
                        list: {},
                        edit: {
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        },
                        ufo_cs_ss_10: {
                            $target: 'edit'
                        },
                        log_info: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'contractTotalNum',
                    name: '合同数量',
                    originProp: 'contractTotalNum',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            type: 'inputNumber',
                            disabled: true,
                            option: {},
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        },
                        ufo_cs_ss_10: {
                            $target: 'edit'
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(select_1.ApprovalStatus, {
                    prop: 'applyStatus',
                    name: '审批状态',
                    originProp: 'applyStatus',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'overdueRecordIds',
                    name: '诉讼合同',
                    originProp: 'overdueRecordIds',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'select',
                            required: true,
                            slot: {
                                render(payload) {
                                    const value = payload.form.data.overdueRecordIds;
                                    return (0, vue_1.h)(ContractArea_vue_1.default, {
                                        type: 'info',
                                        value: value
                                    });
                                }
                            }
                        },
                        ufo_cs_ss_10: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'overdueRecord',
                    name: '诉讼合同',
                    originProp: 'overdueRecordIds',
                    originFrom: 'local',
                    post(value) {
                        return value.map(element => element.id).join(',');
                    },
                    mod: {
                        edit: {
                            type: 'select',
                            required: true,
                            slot: {
                                render(payload) {
                                    const list = payload.form.data.overdueRecord;
                                    return (0, vue_1.h)(ContractArea_vue_1.default, {
                                        type: 'build',
                                        list: list
                                    });
                                }
                            }
                        },
                        build: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'remark',
                    name: '备注',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdBy',
                    name: 'createdBy',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdName',
                    name: '创建人',
                    originProp: 'createdName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedBy',
                    name: '无',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '无',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'applyComment',
                    name: '无',
                    originProp: 'applyComment',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'taskId',
                    name: '无',
                    originProp: 'taskId',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            litigation_1.default.litigationApplicationList.require(Object.assign(Object.assign({}, this.$getSearch()), { pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = litigationApplication;
